<template>
  <div v-if="showPlaceholder || avatarURL == null" class="avatar">
    {{ initials }}
  </div>
  <img
    style="object-fit: cover"
    alt=""
    @error="imgError = true"
    v-else
    class="avatar"
    :src="avatarURL"
  />
</template>

<script>
export default {
  name: "ParticipantAvatar",
  props: ["participant"],
  data() {
    return { imgError: false };
  },
  computed: {
    currentUser() {
      return this.$store.state.user;
    },
    initials() {
      const [firstName, lastName] = this.username.toUpperCase().split(" ");
      const firstLetter = firstName[0];
      const secondLetter = lastName ? lastName[0] : firstName[1];
      return `${firstLetter}${secondLetter}`;
    },
    username() {
      return (
        this.participant.userName ??
        this.participant.username ??
        this.participant.user_name
      );
    },
    meetingId() {
      return this.$store.state.meeting.meeting?.id;
    },
    userId() {
      return this.participant.userId ?? this.participant.user_id;
    },
    meetingToken() {
      const token = this.$store.state.meeting.meeting?.token;
      return token.temporary ? null : token.value;
    },
    showPlaceholder() {
      return this.avatarURL == null || this.imgError;
    },
    avatarURL() {
      if (this.participant.isLocal && this.currentUser) {
        return this.currentUser.photoURL;
      } else if (this.participant.photoURL) {
        return this.participant.photoURL;
      } else if (this.meetingToken) {
        return `${process.env.VUE_APP_BACKEND_API_URL}/meetings/${this.meetingId}/participants/${this.userId}/photo?meeting_token=${this.meetingToken}`;
      } else {
        return null;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.avatar {
  height: 48px;
  width: 48px;
  border-radius: 12px;

  @media screen and (min-width: 1280px) {
    height: 64px;
    width: 64px;
    border-radius: 16px;
  }
}
</style>
